import { ReactElement } from 'react';
import { UIButton } from '@/ui';
import { useAssignTaskAction } from '../actions';
import { useTasksTranslation } from '../hooks';

const HEIGHT = 32;

type AssignAlertButtonProps = {
    taskId: string;
};
export function AssignAlertButton({
    taskId
}: AssignAlertButtonProps): ReactElement {
    const { t } = useTasksTranslation();
    const { assign, loading } = useAssignTaskAction({ taskId });
    return (
        <UIButton
            variant="primary"
            onClick={() => {
                assign().catch(() => {}); // Error handled in the action
            }}
            loading={loading}
            customHeight={HEIGHT}
            leftIcon="arrow-down-circle"
        >
            {t('components.assign_alert_button.label')}
        </UIButton>
    );
}
